import React, { useContext, useEffect, useState } from "react";
import { ZoozaApi } from "../services/Axios";
import { useParams } from "react-router-dom";

import "../styles/attendance.css";
import "moment/min/locales";

import { handleError, msg } from "../services/common-functions";
import { useTranslation } from "react-i18next";
import { ZoozaContextTypes } from "../types/types";
import { ZoozaContext } from "../services/zooza.context";

const InputStyledRadioGroup = ({
  status,
  registration_id,
  user_id,
  getAttendance,
  setErrorMessage,
}: {
  status: string | null | undefined;
  registration_id: number | null | undefined;
  user_id: number | null | undefined;
  getAttendance: () => void;
  setErrorMessage: (message: string) => void;
}) => {
  const { t } = useTranslation();
  const { userData } = useContext<ZoozaContextTypes>(ZoozaContext);
  const [loading, setLoading] = useState(false);
  const isAlowed = (req_roles: string[], role = userData?.user.role) => {
    return req_roles.includes(String(role));
  };
  const isMember = isAlowed(["member", "external_member"]);

  const attendance_options = [
    {
      label: t("enums.attendance.going"),
      value: "going",
    },
    {
      label: t("enums.attendance.attended"),
      value: "attended",
    },
    {
      label: t("enums.attendance.canceled"),
      value: "canceled",
    },
    {
      label: t("enums.attendance.noshow"),
      value: "noshow",
    },
  ];
  if (isMember) {
    attendance_options.pop();
    attendance_options.shift();
  }
  const { id } = useParams();
  const [varStatus, setStatus] = useState<string | null | undefined>(status);
  const onClick = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setLoading(true);
    setErrorMessage("");
    e.preventDefault();
    if (varStatus !== e.currentTarget.value) {
      try {
        const { data } = await ZoozaApi.put(
          `/registrations/${registration_id}`,
          {
            action: "set_attendance",
            attendance: e.currentTarget.value,
            event_id: id,
            user_id: user_id,
          }
        );

        if (data) {
          getAttendance();
        }
      } catch (error: any) {
        const message = handleError(error.response.data, "message");
        setErrorMessage(message || "");
      }
    }
    setLoading(false);
  };
  useEffect(() => {
    setStatus(status);
  }, [status]);
  return (
    <div className={"styled_radio_group"}>
      {attendance_options.map((e, index) => (
        <button
          key={index}
          className={`styled_radio_group button ${
            varStatus === e.value ? "active" : ""
          }
          ${loading ? "loading" : ""}`}
          value={e.value}
          onClick={onClick}
        >
          {e.label}
        </button>
      ))}
    </div>
  );
};

export const AttendanceManager = ({
  status,
  registration_id,
  getAttendance,
  user_id,
}: {
  status: string | null | undefined;
  registration_id?: number | null | undefined;
  getAttendance: () => void;
  user_id: number | null | undefined;
}) => {
  const [errorMessage, setErrorMessage] = useState<string>("");
  return (
    <div className="attendance_manager">
      <p className="attendance_label">
        <em
          className={
            status === "going" || status === "attended"
              ? "bullet_green"
              : status === "canceled"
              ? "bullet_orange"
              : status === "noshow"
              ? "bullet_red"
              : ""
          }
        ></em>
        <strong>{" " + msg(status || "")}</strong>
      </p>
      <div className="select">
        <div>
          <InputStyledRadioGroup
            registration_id={registration_id}
            status={status}
            user_id={user_id}
            getAttendance={() => getAttendance()}
            setErrorMessage={setErrorMessage}
          />
        </div>
      </div>
      <div className="attendance_actions">
        <p style={{ color: "red" }}>{errorMessage}</p>
      </div>
    </div>
  );
};
